import { Routes } from '@angular/router';
import { RoutesUrl } from '@app/routes.enum';
import { authGuard } from '@app/guards/auth.guard';
import { RoleGuard } from '@app/guards/role.guard';
import { PermissionGuard } from '@app/guards/permission.guard';
import { tipoRolGuard } from '@app/guards/tipo-rol.guard';
// TEMPORAL: solo se usa en las rutas de portal, deshabilitadas abajo.
// import { subdominioPortalGuard } from '@app/guards/subdominio-portal.guard';
import { MainComponent } from '@app/pages/main/main.component';

export const routes: Routes = [

  // --- RUTA PÚBLICA: LOGIN ---
  // Rutas externas sin el layout principal.
  {
    path: 'login',
    loadChildren: () =>
      import('./pages/login/login.routes').then((r) => r.LoginRoutes),
    data: { noindex: true }
  },
  // TEMPORAL: rutas de portal deshabilitadas.
  // {
  //   path: 'portal', // La URL base será /portal
  //   // canActivateChild (no canActivate): el guard necesita el `data` de cada ruta hija
  //   // (ej. permiteSubdominioEquipo), que no está disponible en el snapshot del padre.
  //   canActivateChild: [subdominioPortalGuard],
  //   loadChildren: () =>
  //     import('./pages/portal/portal.routes').then((r) => r.PortalRoutes),
  // },

  // --- RUTAS PRIVADAS: DENTRO DEL LAYOUT PRINCIPAL ---
  // Esta ruta carga el MainComponent, que contiene las barras de navegación.
  // Está protegida por el authGuard.
  {
    path: 'main', // Usaremos '/main' como la ruta base para todo el contenido privado.
    component: MainComponent,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        redirectTo: RoutesUrl.DASHBOARD,
        pathMatch: 'full',
      },
      {
        path: RoutesUrl.LOGIN,
        loadChildren: () =>
          import('./pages/login/login.routes').then((r) => r.LoginRoutes),
      },
      {
        path: RoutesUrl.DASHBOARD,
        canActivate: [authGuard],
        loadChildren: () =>
          import('./pages/dashboard/dashboard.routes').then(
            (r) => r.DashboardRoutes
          ),
      },
      {
        path: RoutesUrl.REPORTES,
        canActivate: [authGuard],
        loadChildren: () =>
          import('./pages/reportes/reportes.routes').then(
            (r) => r.ReportesRoutes
          ),
      },
      {
        path: RoutesUrl.EQUIPOS,
        canActivate: [authGuard],
        loadChildren: () =>
          import('./pages/equipos/equipos.routes').then(
            (r) => r.EquiposRoutes
          ),
      },
      {
        path: RoutesUrl.ESCUELAS,
        canActivate: [authGuard, tipoRolGuard('GLOBAL')],
        loadChildren: () =>
          import('./pages/escuelas/escuelas.routes').then(
            (r) => r.EscuelasRoutes
          ),
      },
      {
        path: RoutesUrl.ALUMNOS,
        canActivate: [authGuard],
        loadChildren: () =>
          import('./pages/alumnos/alumnos.routes').then(
            (r) => r.AlumnosRoutes
          ),
      },
      {
        path: RoutesUrl.FAMILIAS_ALUMNOS,
        canActivate: [authGuard],
        loadChildren: () =>
          import('./pages/alumnos/familias/familias-alumnos.routes').then(
            (r) => r.FamiliasAlumnosRoutes
          ),
      },
      {
        path: RoutesUrl.LIGAS,
        canActivate: [authGuard, tipoRolGuard('GLOBAL')],
        loadChildren: () =>
          import('./pages/ligas/ligas.routes').then(
            (r) => r.LigasRoutes
          ),
      },
      {
        path: RoutesUrl.NOTICIA_TAGS_GLOBALES,
        canActivate: [authGuard, tipoRolGuard('GLOBAL')],
        loadChildren: () =>
          import('./pages/noticias-tags-globales/noticias-tags-globales.routes').then(
            (r) => r.NoticiasTagsGlobalesRoutes
          ),
      },
      {
        path: RoutesUrl.SEDES,
        canActivate: [authGuard, PermissionGuard],
        data: { permiso: 'gestionar-sedes' },
        loadChildren: () =>
          import('./pages/sedes/sedes.routes').then(
            (r) => r.SedesRoutes
          ),
      },
      {
        path: RoutesUrl.NIVELES_GRADOS,
        canActivate: [authGuard, PermissionGuard],
        data: { permiso: 'gestionar-niveles-grados' },
        loadChildren: () =>
          import('./pages/config/niveles-grados/niveles-grados.routes').then(
            (r) => r.NivelesGradosRoutes
          ),
      },
      {
        path: RoutesUrl.CICLOS_Y_GRUPOS,
        canActivate: [authGuard, PermissionGuard],
        data: { permiso: 'gestionar-grupos' },
        loadChildren: () =>
          import('./pages/academico/ciclos-grupos/ciclos-grupos.routes').then(
            (r) => r.CiclosGruposRoutes
          ),
      },
      {
        path: RoutesUrl.ARBITROS,
        canActivate: [authGuard, PermissionGuard],
        data: { permiso: 'gestionar-arbitros' },
        loadChildren: () =>
          import('./pages/arbitros/arbitros.routes').then(
            (r) => r.ArbitrosRoutes
          ),
      },
      {
        path: RoutesUrl.JUGADORES,
        canActivate: [authGuard],
        loadChildren: () =>
          import('./pages/jugadores/jugadores-global/jugadores-global.routes').then(
            (r) => r.JugadoresGlobalRoutes
          ),
      },


      {
        path: RoutesUrl.MIEQUIPO,
        canActivate: [authGuard],
        loadChildren: () =>
          import('./pages/equipos/mi-equipo/mi-equipo.routes').then(
            (r) => r.MiEquipoRoutes
          ),
      },
      {
        path: RoutesUrl.MISJUGADORES,
        canActivate: [authGuard],
        loadChildren: () =>
          import('./pages/jugadores/mis-jugadores/mis-jugadores.routes').then(
            (r) => r.MisJugadoresRoutes
          ),
      },
      {
        path: RoutesUrl.FAMILIAS,
        canActivate: [authGuard],
        loadChildren: () =>
          import('./pages/jugadores/familias/familias.routes').then(
            (r) => r.FamiliasRoutes
          ),
      },
      {
        path: RoutesUrl.USUARIOS_ADMIN,
        canActivate: [authGuard, PermissionGuard],
        data: { permiso: ['gestionar-usuarios-escuela'] },
        loadChildren: () =>
          import('./pages/usuarios-admin/usuarios-admin.routes').then(
            (r) => r.UsuariosAdminRoutes
          ),
      },
      {
        path: RoutesUrl.ROLES_ESCUELA,
        canActivate: [authGuard, PermissionGuard],
        data: { permiso: ['crear-roles-escuela'] },
        loadChildren: () =>
          import('./pages/roles-escuela/roles-escuela.routes').then(
            (r) => r.RolesEscuelaRoutes
          ),
      },
      {
        path: RoutesUrl.CATEGORIAS_DIVISIONES,
        canActivate: [authGuard, PermissionGuard],
        data: { permiso: ['gestionar-categorias', 'gestionar-divisiones'] },
        loadChildren: () =>
          import('./pages/categorias-divisiones/categorias-divisiones.routes').then(
            (r) => r.CategoriasDivisionesRoutes
          ),
      },
      {
        path: RoutesUrl.FINEQ,
        canActivate: [authGuard, PermissionGuard],
        data: { permiso: 'gestionar-financiero' },
        loadChildren: () =>
          import('./pages/financiero-equipo/financiero-equipo.routes').then(
            (r) => r.FinancieroEquipoRoutes
          ),
      },
      {
        path: RoutesUrl.FINLI,
        canActivate: [authGuard],
        loadChildren: () =>
          import('./pages/financiero-liga/financiero-liga.routes').then(
            (r) => r.FinancieroLigaRoutes
          ),
      },
      {
        path: RoutesUrl.DOCS,
        canActivate: [authGuard, RoleGuard],
        // Ruta compartida GLOBAL (catálogo de liga) y EQUIPO (catálogo del equipo),
        // por eso se valida por rol y no por permiso equipo-específico.
        data: { rol: ['ROOT', 'ADMIN', 'PROPIETARIO', 'ROOT_EQUIPO', 'ADMINISTRADOR'] },
        loadChildren: () =>
          import('./pages/documentos/documentos.routes').then(
            (r) => r.DocumentosRoutes
          ),
      },
      {
        path: RoutesUrl.NOTICIAS,
        canActivate: [authGuard, RoleGuard],
        data: { rol: ['ROOT', 'ADMIN'] },
        loadChildren: () =>
          import('./pages/noticias/noticias.routes').then(
            (r) => r.NoticiasRoutes
          ),
      },
      {
        path: RoutesUrl.TORNEOS,
        canActivate: [authGuard],
        loadChildren: () =>
          import('./pages/torneos/torneos.routes').then(
            (r) => r.TorneosRoutes
          ),
      },
      {
        path: RoutesUrl.MISTAFF,
        canActivate: [authGuard],
        loadChildren: () =>
          import('./pages/staff/mi-staff/mi-staff.routes').then((r) => r.MiStaffRoutes),
      },
      {
        path: RoutesUrl.CRM,
        canActivate: [authGuard],
        loadChildren: () =>
          import('./pages/crm/crm.routes').then((r) => r.CrmRoutes),
      },
      {
        path: RoutesUrl.CRMLI,
        // TODO: gating por crm-full-liga pendiente en backend
        canActivate: [authGuard],
        loadChildren: () =>
          import('./pages/crm-liga/crm-liga.routes').then((r) => r.CrmLigaRoutes),
      },


    ]
  },

  // --- REDIRECCIONES GLOBALES ---
  {
    // TEMPORAL: con el portal deshabilitado, la raíz ('/') redirige a '/main'.
    // Si requiere login y está logueado, el authGuard lo dejará pasar. Si no, lo mandará a '/login'.
    path: '',
    redirectTo: 'main',
    pathMatch: 'full',
  },
  {
    // Cualquier otra ruta que no coincida con las anteriores, redirige a '/main'.
    path: '**',
    redirectTo: 'main',
  },
];
